/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

/**
 * Drive delegates sign-in to the accounts app, so there is deliberately no
 * `login` here: accounts authenticates the user and calls vecros-api
 * `/auth/session`, which sets the VCS_SESSION cookie drive reads below.
 * Password, MFA and recovery flows all live in accounts.
 */

/** Current session's claims. 401 here is the canonical "not logged in" signal. */
export const getMe = async () => {
  const { data } = await client.get("/auth/me");
  return data;
};

/** Clears drive's session cookie. The caller then hands off to accounts. */
export const logout = async () => {
  const { data } = await client.post("/auth/logout");
  return data;
};
